import Vue from "vue";
import Vuex from "vuex";

import clients from "./clientDashboard";
import main from "./main.store";
import user from "./user.store";
import tasks from "./tasks.store";
import tags from "./main.store/tag.store";
import globalSearch from  "./globalSearch"
import system from "./system.store";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    clients,
    main,
    user,
    tasks,
    tags,
    system,
    globalSearch
  }
});
